// apps/app/src/audio/useAudioDirector.ts
export type MusicMode = 'menu' | 'single' | 'combat' | 'victory' | 'defeat';

export interface MusicDerivationInput {
  readonly mode: MusicMode;
  readonly recentCombat: boolean;
  readonly doctrine: string | null;
}

export function deriveMusicTrack(input: MusicDerivationInput): string {
  if (input.mode === 'menu') return 'music_title';
  if (input.mode === 'victory') return 'music_victory';
  if (input.mode === 'defeat') return 'music_defeat';
  if (input.recentCombat) return 'music_combat';
  if (input.doctrine) return `music_doctrine_${input.doctrine}`;
  return 'music_peace';
}

export interface AmbientDerivationInput {
  readonly biome: string;
  readonly overCity?: boolean;
}

export function deriveAmbientTrack(input: AmbientDerivationInput): string | null {
  if (input.overCity) return 'ambient_city';
  const map: Record<string, string> = {
    plains: 'ambient_plains',
    forest: 'ambient_forest',
    desert: 'ambient_desert',
    mountain: 'ambient_mountain',
    hills: 'ambient_mountain',
    tundra: 'ambient_tundra',
    coast: 'ambient_coast',
    ocean: 'ambient_coast',
    river: 'ambient_coast',
  };
  return map[input.biome] ?? null;
}
